export const COLORS = {
    red: `#DF1715`,
    offwhite: `#D9D9D9`,
    white: `#FFFFFF`,
    grey: `#B6B6B6`,
    ash: `#242424`,
    dark: {
      100: `#434448`,
      300: `#0C0C0C`,
      500: `#4A4A4A`,
      700: `#202020`,
    },
    lavendar: `#FFEEEE`,
    yellow: `#E8D849`,
    green: `#49E8D5`,
    blue: `#499CE8`,
    salsa: `#E84949`,
};

export const WEIGHTS = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
    black: 900,
}

export const BREAKPOINTS = {
    phone: 600,
    tablet: 950,
    laptop: 1300,
  };
  
  export const QUERIES = {
    phoneAndSmaller: `(max-width: 
      ${BREAKPOINTS.phone / 16 }rem)`,
    tabletAndSmaller: `(max-width: 
      ${BREAKPOINTS.tablet / 16 }rem)`,
    laptopAndSmaller: `(max-width: 
      ${BREAKPOINTS.laptop / 16 }rem)`,
    laptopAndUp: `(min-width: 
      ${BREAKPOINTS.laptopMin / 16}rem)`,
  };